// Imports
import AxiosConfig from './serverAxiosConfig'
import firebase from '../config/FirebaseConfig'
import { createQuery } from '../../utils/filterUtils'

const getDiscoveryBrands = async (nextId, filters) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const params = {
    // Create the filters
    ...createQuery(filters),
    next: nextId
  }

  const { data } = await AxiosConfig.get(
    '/brands/discovery',
    {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getBrandAnalytics = async (pageId) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    `/brands/analytics-beta/${pageId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getBrandBulkAnalytics = async () => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    '/brands/analytics-beta/bulk',
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getCreativeTests = async (nextId, brandId) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const params = {
    next: nextId
  }

  const { data } = await AxiosConfig.get(
    `/brands/creative-tests/${brandId}`,
    {
      params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getPinnedCreativeTests = async (dates, brandId) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const payload = {
    dates: dates
  }

  const { data } = await AxiosConfig.post(
     `/brands/pinned-creative-tests/${brandId}`,
     payload,
     {
       headers: {
         Authorization: `Bearer ${token}`
       }
     }
  )

  return data
}

const createSpyderBrand = async (pageId) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
	'/brands/spyder',
	{
	  pageId
	},
	{
	  headers: {
		Authorization: `Bearer ${token}`
	  }
	}
  )

  return data
}

export default {
  getBrandBulkAnalytics,
  getCreativeTests,
  getDiscoveryBrands,
  getBrandAnalytics,
  getPinnedCreativeTests,
  createSpyderBrand
}
